// Ringback while the agent joins: the Indian ring cadence (400 Hz, on 0.4 s, off 0.2 s,
// on 0.4 s, off 2 s), synthesized so it costs no download. Like any page sound, it may be
// held until the caller taps; `resume` is called from the tap.
const CYCLE_S = 3.2;
const BURSTS: [number, number][] = [
  [0, 0.4],
  [0.6, 1.0],
];

export class Ringback {
  private ctx: AudioContext | null = null;
  private timer: ReturnType<typeof setInterval> | undefined;

  start(): void {
    if (this.ctx) return;
    const ctx = new AudioContext();
    this.ctx = ctx;
    const gain = ctx.createGain();
    gain.gain.value = 0;
    gain.connect(ctx.destination);
    const tone = ctx.createOscillator();
    tone.frequency.value = 400;
    tone.connect(gain);
    tone.start();

    let next = ctx.currentTime + 0.05;
    const schedule = () => {
      // Keep one cycle ahead of the clock; a suspended context simply does not advance.
      while (next < ctx.currentTime + CYCLE_S) {
        for (const [on, off] of BURSTS) {
          gain.gain.setTargetAtTime(0.12, next + on, 0.005);
          gain.gain.setTargetAtTime(0, next + off, 0.005);
        }
        next += CYCLE_S;
      }
    };
    schedule();
    this.timer = setInterval(schedule, 1000);
    void ctx.resume().catch(() => {});
  }

  /** Call inside a tap: browsers that blocked the ring on load allow it now. */
  resume(): void {
    void this.ctx?.resume().catch(() => {});
  }

  stop(): void {
    clearInterval(this.timer);
    void this.ctx?.close().catch(() => {});
    this.ctx = null;
  }
}
